import CheckIcon from '@mui/icons-material/Check';

import { isSlideComponentHkcsQ1, Question } from '@/types/slide';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatDuration } from '../../format';
import { ResultCardUnsupported } from '../cards/ResultCardUnsupported';
import { ResultContainer, ResultTitle } from '../ResultCard';

import { ResultContentHkcsQ1 } from './contents/ResultContentHkcsQ1.legacy';

export const ResultCardHkcsQ1: React.FC<{ question: Question }> = ({ question }) => {
    const { t } = useTranslation();

    if (!isSlideComponentHkcsQ1(question)) {
        return <ResultCardUnsupported question={question} />;
    }

    const caption = question.answers.length === 0 ? t('result.message.noResult') : t('result.message.hkcsQ1.caption');
    const answer = question.answers[0];
    const timeSpent = formatDuration(question.answers.reduce((total, answer) => total + (new Date(answer.endTime).getTime() - new Date(answer.startTime).getTime()), 0) / 1000);

    return (
        <ResultContainer>
            <Stack spacing={1} sx={{ width: '640px' }}>
                <ResultTitle variant='h5'>{t('slide.legacy.hkcsQ1.title')}</ResultTitle>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
                    <Typography color={question.answers.length > 0 ? 'text.secondary' : 'text.warning'}>{caption}</Typography>
                    {question.answers.length > 0 && (
                        <Typography color='text.secondary'>
                            {t('result.label.timeSpent')}: {timeSpent}
                        </Typography>
                    )}
                </Box>
            </Stack>
            <ResultContentHkcsQ1 question={question} />
            <Box
                sx={(theme) => ({
                    backgroundColor: !answer ? 'transparent' : (theme.vars || theme).palette.success.main,
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    p: 1,
                    borderRadius: '4px',
                })}
            >
                {!answer ? (
                    <Typography variant='h5' color='warning' textAlign={'center'}>
                        {t('result.label.noResult')}
                    </Typography>
                ) : (
                    <CheckIcon style={{ color: 'white' }} />
                )}
            </Box>
        </ResultContainer>
    );
};
